import { Component } from "@angular/core";
import { UserSettingsCategory } from "../user-settings-category";
import { UserSubscriptionTableComponent } from "./subscriptions/user-subscription-table.component";
import { EventBroker } from "@ponder-core/events/eventBroker";
import { AuthService } from "@ponder-core/auth/auth.service";
import { AuthSession } from "@ponder-core/auth/auth-session";
import { LoadingComponent } from "@ponder-shared/loading/loading.component";
import { UnauthorizedComponent } from "@ponder-shared/components/unauthorized.component";
import { UserPaymentMethodsComponent } from "./payments/user-payment-methods.component";

@Component({
    selector: "user-account-billing-settings",
    imports: [ LoadingComponent, UnauthorizedComponent, UserSubscriptionTableComponent, UserPaymentMethodsComponent ],
    templateUrl: "./user-account-billing-settings.component.html"
})
export class UserAccountBillingSettingsComponent {
    public isLoading: boolean = true;
    public authSession?: AuthSession;
    
    public constructor(private events: EventBroker, private authService: AuthService) {
        
    }

    public ngOnDestroy(): void {

    }
    
    public ngOnInit(): void {
        this.events.account.categorySelected.emit(UserSettingsCategory.Billing);

        this.authService.getSessionAsync().then((authSession?: AuthSession) => {
            this.authSession = authSession;
            this.isLoading = false;
        });
    }
}